import { Box, Typography } from '@mui/material';
import { t } from '../../../constants/helperTranslations';
import { useLocale } from '../../../contexts/locale.context';

const SemiProductsHelper = () => {
  const { lang } = useLocale();

  return (
    <Box>
      <Typography sx={{ mb: 2 }}>{t.semiproduct_part1[lang]}</Typography>

      <Typography sx={{ mb: 2 }}>{t.semiproduct_part2[lang]}</Typography>

      <Typography sx={{ mb: 2 }}>{t.semiproduct_part3[lang]}</Typography>

      <Box sx={{ height: 2 }} />
    </Box>
  );
};

export default SemiProductsHelper;
